/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentCardManageResultProcessParamsApiModel } from './payment-card-manage-result-process-params';

export interface PaymentCardManageResultApiModel {
  /**
   * Error text
   */
  error?: string;
  process_params?: PaymentCardManageResultProcessParamsApiModel;
  /**
   * Object type
   */
  type?: PaymentCardManageResultApiModelTypeEnum;
  /**
   * Object value
   */
  value?: string;
}
export enum PaymentCardManageResultApiModelTypeEnum {
  Status = 'status',
  Url = 'url'
}
